export default __webpack_public_path__ + "static/fullCup-41cf833631f7cd040c3028771c5b6938.png";